import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { supabase } from "@/lib/supabase"

export default function AdminPage() {

  const navigate = useNavigate()

  const [nome, setNome] = useState("")
  const [categoria, setCategoria] = useState("")
  const [durata, setDurata] = useState("")
  const [prezzo, setPrezzo] = useState("")
  const [imageUrl, setImageUrl] = useState("")
  const [loading, setLoading] = useState(false)

  // 🔐 PROTEZIONE LOGIN
  useEffect(() => {
    const checkUser = async () => {
      const { data } = await supabase.auth.getUser()

      if (!data.user) {
        navigate("/login")
      }
    }

    checkUser()
  }, [navigate])

  // ➕ AGGIUNTA TRATTAMENTO
  const handleAdd = async (e: any) => {
    e.preventDefault()
    setLoading(true)

    const { error } = await supabase
      .from("trattamenti")
      .insert([
        {
          nome,
          categoria,
          durata,
          prezzo,
          immagine: imageUrl
        }
      ])

    if (error) {
      console.error(error)
      alert("Errore, controlla Supabase")
    } else {
      alert("Trattamento aggiunto ✅")

      // reset campi
      setNome("")
      setCategoria("")
      setDurata("")
      setPrezzo("")
      setImageUrl("")
    }

    setLoading(false)
  }

  // 🔓 LOGOUT
  const handleLogout = async () => {
    await supabase.auth.signOut()
    localStorage.removeItem("isAdmin")
    window.location.href = "/trattamenti"
  }

  return (
    <div className="min-h-screen bg-[#f8f5f1] px-6 py-20">

      <div className="max-w-2xl mx-auto bg-white p-10 rounded-2xl shadow">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-semibold">
            Admin • Aggiungi trattamento
          </h1>

          <button
            onClick={handleLogout}
            className="text-sm px-4 py-2 border rounded-lg hover:bg-black hover:text-white transition"
          >
            Logout
          </button>
        </div>

        {/* FORM */}
        <form onSubmit={handleAdd} className="flex flex-col gap-4">

          <input
            type="text"
            placeholder="Nome trattamento"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="px-4 py-3 border rounded-lg"
            required
          />

          <input
            type="text"
            placeholder="Categoria (viso, corpo...)"
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
            className="px-4 py-3 border rounded-lg"
            required
          />

          <input
            type="text"
            placeholder="Durata (es. 60 min)"
            value={durata}
            onChange={(e) => setDurata(e.target.value)}
            className="px-4 py-3 border rounded-lg"
          />

          <input
            type="text"
            placeholder="Prezzo (es. da €80)"
            value={prezzo}
            onChange={(e) => setPrezzo(e.target.value)}
            className="px-4 py-3 border rounded-lg"
          />

          <input
            type="text"
            placeholder="URL immagine (/images/trattamenti/xxx.jpg)"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            className="px-4 py-3 border rounded-lg"
          />

          <button
            type="submit"
            className="bg-black text-white py-3 rounded-lg mt-4 hover:scale-105 transition"
          >
            {loading ? "..." : "Aggiungi trattamento"}
          </button>

        </form>

      </div>

    </div>
  )
}